<template>
    <b-modal :id="modalid" @ok="ok" @cancel="cancel">
        <div slot="modal-header"><b-icon icon="x-circle" scale="2.5" /></div>
        {{ message }}
        <div slot="modal-footer">
            <p-button type="default" size="sm" outline @click="cancel">{{ $t('button.no') }}</p-button>
            <p-button type="success" size="sm" outline @click="ok"><i class="fa fa-times"></i>{{ $t('button.yes') }}</p-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'CanceledDeparturesConfirm',
    props: {
        modalid: { type: String, default: 'confirm-modal' },
        message: { type: String, default: 'confirm' },
        value: { type: String, default: '' }
    },
    methods: {
        ok() {
            this.$emit('ok', this.value);
            this.$bvModal.hide(this.modalid);
        },
        cancel() {
            this.$emit('cancel');
            this.$bvModal.hide(this.modalid);
        },
        show() {
            this.$bvModal.show(this.modalid);
        },
    },
}
</script>

<style scoped lang="scss">
button i {
    margin-right: 5px;
}

.modal-dialog {
    width: 400px;
}

.danger {
    background: red;
    color: white;
}

.modal-content {
    border-radius: 5px;
    text-align: center;
}

.modal-header {
    color: #f15e5e;
    padding-top: 40px;
}

.modal-footer {
    justify-content: center;
    padding-bottom: 25px;
}

modal-footer button {
    margin: 10px 5px;
}
</style>
